(function ($, undefined) {
	'use strict';
	var utils;
	let formValidator;

	var init = function () {
		const form = $('#buttons-form');
		utils = Fw.component.models().utils;
		formValidator = Fw.component.models().form;
		displayForms();
		addNewFieldForm();

		$(document).on('click','.input-icon-ctn__icon', (e) => {
			let form = e.currentTarget;
			$(form).parent().parent().remove();
		});
		const documentTypeForm = $('.add-buttons-document-type');
		$('.form-item-upload_plus-btn input', documentTypeForm).on('change', onDocumentInputChange);
		form.on('submit', onButtonFormSubmit);
		$('.select-state-input, .select-country-input', form).on('change', getCitiesIfNecessary);
		$('[name="button-activate"]').on('change', onChangeActivate);
		$('[name="button-security"]').on('change', onChangeBtnSecurity);
		
		$('[name="button-emergency"]').on('change', onChangeEmergency);

		$('.add-buttons-form__add-contact-btn').on('click', onAddButtonContactBtnClick);
		$('.button-contacts-section').on('click', '.remove-button-contact-btn', onRemoveButtonContactBtnClick);
		
		$(document).on("select2:select","#add-buttons-form-checklist-checklist-input",checklistFunction);
		$(document).on('click',".confirm-reassign", confirmReassign);
	};

	var confirmReassign=function(e){
		const id=$(e.currentTarget).attr("data-id");
		const newId=$(e.currentTarget).attr("data-new-id");
		const checklistId=$(e.currentTarget).attr("data-checklist-id");
		const popup = $(e.currentTarget).closest('.stool-shared-popup');

		const deletePopupInput = popup.find('.delete-popup-input');
		var confirmReassignBtn = popup.find('.confirm-reassign');
		var cancelDeleteBtn = popup.find('.popup-cancel');
		
		confirmReassignBtn.addClass('btn-processing_active');
		cancelDeleteBtn.css('display', 'none');
		var select=$("#add-buttons-form-checklist-checklist-input");

		if (deletePopupInput.val().toLowerCase() === 'yes') {
			utils.updateGenDataFields(id,["field7"],[""],function(){
				if(newId!="" && newId!=undefined && newId>0){
					utils.updateGenDataFieldsGen(newId,["field7"],[checklistId],true,function(res){
						confirmReassignBtn.removeClass('btn-processing_active');
						select.parent().removeClass('has-processing has-processing_active');
						$(".confirm-checklist-popup").find(".stool-shared-popup").removeClass("visible");
						deletePopupInput.val("");
						if(String(res).endsWith("-0")){
							alert("Checklist is already assigned to any other button! try refreshing the page and try again");
						}else{
							$("input[name='field7']").val(checklistId);
							select.val(checklistId).trigger("change");
						}
					});
				}else {
					confirmReassignBtn.removeClass('btn-processing_active');
					select.parent().removeClass('has-processing has-processing_active');
					$(".confirm-checklist-popup").find(".stool-shared-popup").removeClass("visible");
					deletePopupInput.val("");
					select.val(checklistId).trigger("change");
				}
			});
		} else {
			deletePopupInput.addClass('error');
			confirmReassignBtn.removeClass('btn-processing_active');
			cancelDeleteBtn.css('display', 'block');
			select.parent().removeClass('has-processing has-processing_active');
			$(".confirm-checklist-popup").find(".stool-shared-popup").removeClass("visible");
			deletePopupInput.val("");
			select.val("").trigger("change");
		}
	}

	var checklistFunction=function({currentTarget}){
		var id=currentTarget.value;
		var text=$("#add-buttons-form-checklist-checklist-input").find(":selected").text();
		var select=$("#add-buttons-form-checklist-checklist-input");
		select.parent().addClass('has-processing has-processing_active');
		if(id>0){
			utils.fetchGenDatas({ field1: 'button',field6:'2', field7:id}, (gendatas) => {
				let buttons = gendatas;
				select.parent().removeClass('has-processing has-processing_active');
				if(buttons!=null && buttons!=undefined && buttons.length>0 && buttons[0].field7!=$("input[name='field7']").val()){
					select.val($("input[name='field7']").val()).trigger("change");
					var popup=$(".confirm-checklist-popup").find(".stool-shared-popup");
					popup.addClass("visible");
					popup.find(".delete-popup__text").text("\""+text+"\" checklist is already assigned to \""+buttons[0].field2+"\" button. Are you sure to reassign it to \""+$("input[name='field2']").val()+"\" button?");
					
					popup.find(".confirm-reassign").attr("data-id",buttons[0].id);
					popup.find(".confirm-reassign").attr("data-new-id",$("input[name='id']").val());
					popup.find(".confirm-reassign").attr("data-checklist-id",id);
					popup.find(".stool-shared-popup-close-btn").addClass("confirm-reassign-cancel");
				}else {
					select.val(id).trigger("change");
				}
			});
		}else {
			select.parent().removeClass('has-processing has-processing_active')
			select.val(id).trigger("change");
		};
		
	};

	var onChangeEmergency = function ({ currentTarget }) {
		$('[name="field17"]').val(currentTarget.checked);
	};

	var onChangeActivate = function ({ currentTarget }) {
		$('[name="field5"]').val(currentTarget.checked);
	};
	var onChangeBtnSecurity = function ({ currentTarget }) {
		$('[name="field31"]').val(currentTarget.checked);
	};
	

	var onDocumentInputChange = function () {
		var input = $(this);
		var ctn = input.closest('.form-item-upload');
		var files = input[0].files;
		var idInput = $('[name="associatedId"]');
		var id = idInput.length ? idInput.val() : null;
		$('.site-overlay').addClass('site-overlay_processing');
		utils.uploadSecureFiles(files, (response) => {
			const [id, filename] = response.media.mediaIds[0].split(" - ");
			const select = $('#add-buttons-form-document-input');
			select.append(`<option value="${id}">${filename}</option>`);
			select.val(id);
			select.blur();
			$('.site-overlay').removeClass('site-overlay_processing');
		}, id, $('[name="associatedString"]').val(), utils.UPLOAD_KEY);
	};

	function onButtonFormSubmit(e) {
		const $form = $(e.currentTarget);
		const selectTypeInput = $('.buttons-type-select.updated-select-input').find(":selected");
		const selectTypeVal = selectTypeInput.val();
		const field8 = $('[name="field8"]');
		e.preventDefault();
		formValidator.validateForm($form);
		if (!$form.hasClass('has-error')) {
			switch (selectTypeVal){
				case "0":
					$('[name="field7"]').val('');
					break;
				case "1":
					parseFields();
					break;
				case "2":
					parseChecklists();
					break;
				case "3":
					parseDocuments();
					break;
			}

			$('[name="field13"]').val(field8.length == 0 || field8.val().length == 0);

			parseContacts();

			$('.site-overlay').addClass('site-overlay_processing');
			submitForm($form);
		}
	}

	function submitForm(form) {
		const data = form.formData(true);
		const countrySelect = $('.select-country-input');
		const stateSelect = $('.select-state-input');
		const citySelect = $('#buttons-filter-city-select');

		try {
			data.field3 = tinymce.get($('.field3', form).attr('id')).getContent();
		} catch (ex) {
			// Do nothing and keep what's already in field3.
		}

		if (stateSelect.prop('disabled')) {
			data.field11 = '';
		}

		if (citySelect.prop('disabled')) {
			data.field12 = '';
		}

		if(data.field6=="0"){
			data.field8 = null;
		}
		
		$.ajax({
			url: '/action/manageGenData',
			type: 'POST',
			data,
			complete: ({ responseText }) => {
				if (responseText.indexOf("success-") > -1) {
					let id = responseText.trim().split('success-')[1];
					updateChecklist(data, id).then(() => redirect(data));
				} else {
					redirect(data);
				}
			}
		});
	}

	function redirect(data) {
		let { pageName } = data;
		location.href = pageName;
	}

	function updateChecklist(data, id) {
		let resolveRef;
		const promise = new Promise(resolve => resolveRef = resolve);
		if (data.field6 != '2') {
			return Promise.resolve();
		} else {
			utils.fetchGenDatas({ field5: id }, (gendatas) => {
				let [checklist] = gendatas;

				if (typeof checklist == "undefined" || checklist.id == data.field7) {
					updateFinalChecklist(resolveRef, data, id);
				} else {
					utils.updateGenDataFields(checklist.id, ['field5'], [''], () => {
						updateFinalChecklist(resolveRef, data, id);
					});
				}
			});
		}

		return promise;
	}

	function updateFinalChecklist(resolveRef, data, id) {
		$.ajax({
			url: '/action/manageGenData',
			type: 'POST',
			data: {
				id: data.field7,
				field5: id,
				ajax: true,
			},
			complete: () => resolveRef()
		});
	}

	function parseFields() {
		$('[name="field7"]').val(JSON.stringify({
			fields: $('.add-modify-page-inner-item-ctn__edit_buttons-page').map((i, el) => {
				let textarea = el.querySelector('textarea');
				let text = textarea.value;
				try { text = tinymce.get(textarea.id).getContent(); } catch (e) { /* Voluntarily ignoring error */ }
				return ({
					"name": el.querySelector('input').value,
					"text": text
				});
			}).get()
		}));
	}

	function parseChecklists() {
		$('[name="field7"]').val($('[name="selected-checklist"]').val());
	}

	function parseDocuments() {
		$('[name="field7"]').val($('[name="selected-document"]').val());
	}

	function parseContacts() {
		var form = $('#buttons-form');
		var contacts = {contacts: []};

		$('.button-contact-form:not(.button-contact-form_template)', form).each(function(i, el) {
			var name = $('[name=name]', el).val();
			var phone = $('[name=phone]', el).val();
			var email = $('[name=email]', el).val();
			contacts.contacts.push({
				name,
				phone,
				email
			});
		});
		$('[name=field18]').val(JSON.stringify(contacts));
	}

	function getCitiesIfNecessary() {
		const countrySelect = $('.updated-select-input.select-country-input');
		const stateSelect = $('.updated-select-input.select-state-input:not([disabled])');
		const citySelect = $('#buttons-filter-city-select');
		const set = new Set();

		// citySelect.val('');
		// citySelect.find(":selected").val("City"); 

		if (countrySelect.length && stateSelect.length) {
			citySelect.addClass('has-processing has-processing_active');
			$.ajax({
				url: '/action/fetchGenData',
				type: 'GET',
				dataType: 'json',
				data: {
					field1: 'geolocation',
					field2: countrySelect.find(":selected").val(),
					field3: stateSelect.find(":selected").val(),
				}
			}).then(res => {
				if (typeof res === 'string' || res.length == 0) {
					disableCitySelect();
					return;
				}
				res.sort((locA, locB) => {
					if (locA.field4 < locB.field4) {
						return -1;
					} else if (locA.field4 > locB.field4) {
						return 1;
					} else {
						return 0;
					}
				}).forEach(geoloc => {
					set.add(geoloc.field4);
				});

				citySelect.find('option:not([value=""])').remove();

				set.forEach(city => {
					citySelect.append(`<option>${city}</option>`);
				});

				citySelect.removeAttr('disabled');
				citySelect.removeClass('has-processing has-processing_active');

				citySelect.parent().find(".select2.select2-container.select2-container--default").remove(); 
				citySelect.select2({
					sorter: data => {
					  var firstItem=data.shift();
					  
					  var tempData=data.sort((a, b) =>a.text.localeCompare(b.text));
					  tempData.unshift(firstItem);
					  return tempData;
					} 
				  });
				
				var container=$(citySelect).siblings('.select2-container');
			
				container.css({'display':'block','max-width':'100%','width':'100%','min-width':'100%'});
				
				$(container).find(".select2-selection").css({'height': '47px','border': '1px solid #cbccd9',
				'background-color':'inherit','font-size': '1.4rem',
				'font-family': 'Lato,arial,helvetica,sans-serif'});
				$(container).find('.select2-selection__arrow').css({'height': '44px','right':'10'});
				$(container).find('.select2-selection__rendered').css({'line-height': '44px','padding-left':'18px'});
			}).catch(ex => {
				disableCitySelect();
			});
		} else {
			disableCitySelect();
		}

	}

	function disableCitySelect() {
		const citySelect = $('#buttons-filter-city-select');
		citySelect.val('');
		citySelect.attr('disabled', 'disabled');
		citySelect.removeClass('has-processing has-processing_active');
	}

	const addNewFieldForm = () => {
		const form = $('.add-modify-page-inner-item-ctn__edit_buttons-page:not(.not-first)');
		const addNewFormBtn = $('#add-new-fields-form');
		const formCtn = $('.field-form-ctn');
		addNewFormBtn.on('click', () => {
			const clone = form.clone().addClass('not-first');
			const textarea = clone.find('textarea');
			clone.find('.mce-container').remove();
			textarea.removeAttr('style');
			textarea.attr('id', textarea.attr('id') + Math.floor(Math.random() * 1000000));
			clone.find('input, textarea').val('');
			formCtn.append(clone);
			utils.initTinyMCE(textarea.get(0));
			// const deleteFormIcon = $('.input-icon-ctn__icon');
			// deleteFormIcon.on('click', (e) => {
			// 	let form = e.currentTarget;
			// 	$(form).parent().parent().remove();
			// });
		});
	};

	const displayForms = () => {
		const selectTypeInput = $('.buttons-type-select');
		const parentTypeForm = $('.add-buttons-parent-type');
		const fieldTypeForm = $('.add-buttons-field-type');
		const checklistTypeForm = $('.add-buttons-checklist-type');
		const documentTypeForm = $('.add-buttons-document-type');

		selectTypeInput.on('select2:select', e => {
			var selected=$(e.currentTarget).find(":selected").val();
			$('.add-buttons-child-parent select').attr('name', '');
			
			switch (selected) {
				case '0':
					parentTypeForm.show(300);
					hideFormType(fieldTypeForm);
					hideFormType(checklistTypeForm);
					hideFormType(documentTypeForm);
					break;
				case '1':
					parentTypeForm.hide(0);
					showFormType(fieldTypeForm);
					hideFormType(checklistTypeForm);
					hideFormType(documentTypeForm);
					break;
				case '2':
					parentTypeForm.hide(0);
					hideFormType(fieldTypeForm);
					showFormType(checklistTypeForm);
					hideFormType(documentTypeForm);
					break;
				case '3':
					parentTypeForm.hide(0);
					hideFormType(fieldTypeForm);
					hideFormType(checklistTypeForm);
					showFormType(documentTypeForm);
					break;
				default:
					parentTypeForm.hide(0);
					hideFormType(fieldTypeForm);
					hideFormType(checklistTypeForm);
					hideFormType(documentTypeForm);
					break;
			}
		});
	};

	const showFormType = (typeForm) => {
		typeForm.show(300);
		typeForm.removeClass('js-form-ignore-as-child');
		$('.add-buttons-child-parent select', typeForm).attr('name', 'field8');
	};

	const hideFormType = (typeForm) => {
		typeForm.hide(0);
		typeForm.addClass('js-form-ignore-as-child');
	};

	function onAddButtonContactBtnClick() {
		var btn = $(this);
		var section = btn.closest('.button-contacts-section');
		var forms = $('.button-contacts-section__forms', section);
		var form = $('.button-contact-form_template').clone(true);
		form.removeClass("button-contact-form_template");
		forms.append(form);
	}

	function onRemoveButtonContactBtnClick() {
		var btn = $(this);
		var form = btn.closest('.button-contact-form');
		form.remove();
	}

	$(window).ready(function () {
		init();
	});
})(jQuery);